import React, { createContext, useState, useEffect } from 'react';

import api from '../services/api';

const AuthContext = createContext({
    signed: false, 
    user: {
        id: '',
        name: '',
        last_name: '',
        type: '',
        email: '',
        username: '',
        image: '',
        verified: ''
    },
    token: ''
});

export const AuthProvider = ({ children }) => {
    
    const [user, setUser] = useState(localStorage.getItem('user'));
    const [token, setToken] = useState(localStorage.getItem('token'));
    
    useEffect(() => {
        async function loadStorageData() {
            const storageUser = localStorage.getItem('user');
            const storageToken = localStorage.getItem('token');

            if (storageUser && storageToken) {
                setUser(JSON.parse(storageUser));
                setToken(storageToken);
            }
        }

        loadStorageData();
    }, [])

    async function signIn(signin_email, signin_password, remember) {

        const response = await api.post('/login', {
            signin_email,
            signin_password,
            remember
        });
        const { data } = response.data;

        if(data.user) {
            setUser(data.user);
            setToken(data.token);
      
            localStorage.setItem('user', JSON.stringify(data.user));
            localStorage.setItem('token', data.token);
        }
        return data;

    }

    function signOut() {
        localStorage.removeItem("user");
        localStorage.removeItem("token");
        setUser(null);
        setToken(null);
    }

    return (
        <AuthContext.Provider value={{ signed: !! user, user, token, token, signIn, signOut }} >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext;
